import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/navigation';

import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import MyHead from '../../components/MyHead';
import Image from 'next/future/image';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Scrollbar } from 'swiper';
import { buttonVariants } from '@/components/v2/UI/Button';
import LinkTo from '@/components/LinkTo';
import MaterialCards from '@/components/v2/MaterialCards';
import Link from 'next/link';

const EcolyptPage: React.FC = () => {
  const { t } = useTranslation();

  const prods = useMemo(
    () => [
      {
        title: t('P_ECOLYPT.SECTION-3.CARD-1.TITLE'),
        description: t('P_ECOLYPT.SECTION-3.CARD-1.DESC'),
        link1: '/collections/man/apparel-underwear-evolutyon-biotech',
        link2: '/collections/woman/apparel-underwear-evolutyon-biotech',
        btntext1: t('P_ECOLYPT.SECTION-3.CARD-1.BTN'),
        btntext2: t('P_ECOLYPT.SECTION-3.CARD-1.BTN-2'),
        btntextsoon: t('P_ECOLYPT.SECTION-3.CARD-1.BTNSOON'),
        src: '/v2/materials/ecolypt/evolutyon.jpg',
        coming: ''
      },
      {
        title: t('P_ECOLYPT.SECTION-3.CARD-2.TITLE'),
        description: t('P_ECOLYPT.SECTION-3.CARD-2.DESC'),
        link1: '/collections/man/apparel-underwear-fusyon-biotech',
        link2: '/collections/woman/apparel-underwear-fusyon-biotech',
        btntext1: t('P_ECOLYPT.SECTION-3.CARD-2.BTN'),
        btntext2: t('P_ECOLYPT.SECTION-3.CARD-2.BTN-2'),
        btntextsoon: t('P_ECOLYPT.SECTION-3.CARD-2.BTNSOON'),
        src: '/v2/materials/ecolypt/fusyon.jpg',
        coming: ''
      },
      {
        title: t('P_ECOLYPT.SECTION-3.CARD-3.TITLE'),
        description: t('P_ECOLYPT.SECTION-3.CARD-3.DESC'),
        link1: '/collections/man/apparel-underwear-energyon-biotech',
        link2: '/collections/woman/apparel-underwear-energyon-biotech',
        btntext1: t('P_ECOLYPT.SECTION-3.CARD-3.BTN'),
        btntext2: t('P_ECOLYPT.SECTION-3.CARD-3.BTN-2'),
        btntextsoon: t('P_ECOLYPT.SECTION-3.CARD-3.BTNSOON'),
        src: '/v2/materials/ecolypt/energyon.jpg',
        coming: ''
      }
    ],
    []
  );

  return (
    <div>
      <MyHead />

      <div className="section relative full bg-[#D6E0D6] text-[#A8B9A7] overflow-hidden">
        <div className="section-wrapper relative">
          <div className="grid gap-8 grid-cols-12 md:gap-12 xl:gap-20 mt-10 md:mt-0">
            <div className="md:col-span-8 col-span-12">
              <div className="lead-1 font-normal leading-none">
                {t('P_ECOLYPT.SECTION-1.MATERIAL')}
              </div>
              <div className="lead-1 leading-none">
                {t('P_ECOLYPT.SECTION-1.TITLE')}
              </div>
            </div>
            <div className="col-span-4 hidden md:block"></div>

            <div className="md:col-span-5 col-span-12">
              <div className="md:pr-20 text-body">
                {t('P_ECOLYPT.SECTION-1.DESC')}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="section no-space relative full bg-[#D6E0D6] text-[#A8B9A7] overflow-hidden">
        <div className="relative">
          <Image
            src="/v2/materials/ecolypt/1.jpg"
            alt=""
            width={0}
            height={0}
            sizes="100vw"
            className="w-full h-auto"
          />
        </div>
      </div>

      <div className="section relative full bg-[#D6E0D6] text-[#A8B9A7] overflow-hidden">
        <div className="section-wrapper relative">
          <div className="grid gap-8 grid-cols-12 md:gap-12 xl:gap-20">
            <div className="md:col-span-8 md:col-start-3 col-span-12">
              <div className="text-body text-center">
                {t('P_ECOLYPT.SECTION-1.DESC-2')}
              </div>
              <div className="text-body text-center mt-10">
                {t('P_ECOLYPT.SECTION-1.DESC-3')}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="section relative full smallspace overflow-hidden text-white">
        <Image
          src="/v2/materials/ecolypt/2.jpg"
          alt=""
          width={0}
          height={0}
          sizes="100vw"
          className="w-full h-full absolute object-cover object-center top-0 left-0"
        />

        <div className="section-wrapper relative">
          <div className="grid gap-8 grid-cols-12 md:gap-12 xl:gap-20">
            <div className="md:col-span-4 col-span-12">
              <div className="h3">{t('P_ECOLYPT.SECTION-2.TITLE-1')}</div>
              <div className="text-body md:mt-8 mt-3">
                {t('P_ECOLYPT.SECTION-2.DESC-1')}
              </div>
            </div>
            <div className="md:col-span-4 col-span-12">
              <div className="h3">{t('P_ECOLYPT.SECTION-2.TITLE-2')}</div>
              <div className="text-body md:mt-8 mt-3">
                {t('P_ECOLYPT.SECTION-2.DESC-2')}
              </div>
            </div>
            <div className="md:col-span-4 col-span-12">
              <div className="h3">{t('P_ECOLYPT.SECTION-2.TITLE-3')}</div>
              <div className="text-body md:mt-8 mt-3">
                {t('P_ECOLYPT.SECTION-2.DESC-3')}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="section relative full bg-[#D6E0D6] text-[#A8B9A7] overflow-hidden">
        <div className="section-wrapper relative">
          <div className="grid gap-8 grid-cols-12 mt-10 md:mt-0">
            <div className="text-center col-span-12">
              <div className="h3">{t('P_ECOLYPT.SECTION-3.TITLE')}</div>
            </div>

            <div className="col-span-12">
              <Swiper
                wrapperTag="ul"
                slidesPerView={1.1}
                spaceBetween={16}
                className="materialsSwiper overflow-visible materialsSwiper"
                breakpoints={{
                  768: {
                    slidesPerView: 2.2
                  },
                  1024: {
                    slidesPerView: 3
                  }
                }}
              >
                {prods.map((card, idx) => (
                  <SwiperSlide
                    key={idx}
                    tag="li"
                    data-soon={card.coming}
                    className="rounded-uyn relative aspect-square text-white flex items-center overflow-hidden justify-center"
                  >
                    <Image
                      src={card.src}
                      alt=""
                      width={0}
                      height={0}
                      sizes="100vw"
                      className="w-full absolute top-0 left-0 h-full object-center object-cover z-10"
                    />

                    <div className="flex-col space-y-4 md:p-6 p-4 flex items-center justify-center relative z-40 text-center">
                      <div className="h4">{card.title}</div>
                      <div className="text-body max-w-[500px] mx-auto">
                        {card.description}
                      </div>
                      <div className="space-x-2 not-coming">
                        {card.link1.includes('/collections/') ||
                        card.link1.includes('/sku/') ? (
                          <Link href={card.link1}>
                            <a className={buttonVariants({ variant: 'light' })}>
                              {card.btntext1}
                            </a>
                          </Link>
                        ) : (
                          <LinkTo
                            href={card.link1}
                            className={buttonVariants({ variant: 'light' })}
                          >
                            {card.btntext1}
                          </LinkTo>
                        )}

                        {card.link2.includes('/collections/') ||
                        card.link2.includes('/sku/') ? (
                          <Link href={card.link2}>
                            <a className={buttonVariants({ variant: 'light' })}>
                              {card.btntext1}
                            </a>
                          </Link>
                        ) : (
                          <LinkTo
                            href={card.link2}
                            className={buttonVariants({ variant: 'light' })}
                          >
                            {card.btntext1}
                          </LinkTo>
                        )}
                      </div>
                      <div className="coming-soon hidden pointer-events-none opacity-70">
                        <LinkTo
                          href="/"
                          className={buttonVariants({ variant: 'light' })}
                        >
                          {card.btntextsoon}
                        </LinkTo>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>

      <div className="section relative full overflow-hidden">
        <div className="section-wrapper relative">
          <MaterialCards />
        </div>
      </div>
    </div>
  );
};

export default EcolyptPage;
